<template>
	<v-form ref="form" v-model="isFormValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="titulo"
			:max-width="modalOptions.largura"
			:is-confirmar-desabilitado="!isFormValid"
			:custom-actions="false"
			@close="fecharModal"
			:acao-cancelar="fecharModal"
			:is-confirmar-visivel="isConfirmarVisivel()"
		>
			<template #body>
				<v-row class="mt-4">
					<v-col cols="4">
						<label-personalizado nome-campo="Responsável" class="mb-2"></label-personalizado>
						<p>{{ ocorrencia.autor }}</p>
					</v-col>
					<v-col cols="4">
						<label-personalizado nome-campo="Última Atualização" class="mb-2"></label-personalizado>
						<p>
							{{
								ocorrencia.dataAlteracao
									? ocorrencia.dataAlteracao
									: ocorrencia.dataCadastro | formatDataHourMinuteFilter
							}}
						</p>
					</v-col>
					<v-col cols="4">
						<label-personalizado nome-campo="Atividade" class="mb-2"></label-personalizado>
						<p>{{ ocorrencia.atividade }}</p>
					</v-col>
				</v-row>

				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado nome-campo="Descrição" class="mb-2"></label-personalizado>
						<v-textarea
							readonly
							disabled
							ref="descricao"
							:value="ocorrencia.descricao"
							:rows="4"
							counter="4000"
							class="ma-0 py-0"
						></v-textarea>
					</v-col>
				</v-row>

				<v-row class="mt-4">
					<v-col cols="12">
						<label-personalizado nome-campo="Respostas" class="mb-2"></label-personalizado>
						<v-list>
							<v-list-item-group v-if="ocorrencia.respostas && ocorrencia.respostas.length">
								<v-row v-for="resposta in ocorrencia.respostas" :key="resposta.id" class="pa-0">
									<v-col :id="`resposta-${resposta.id}`" cols="12">
										<span class="cp-text">
											{{ resposta.dataHoraCriacao | formatDataHourMinuteFilter }} -
											{{ resposta.autor }}:
										</span>
										<v-tooltip v-if="habilitaEdicao(resposta)" top>
											<template
												v-az-auth="permissoes.ataOcorrenciaRespostaEditar"
												#activator="{ on, attrs }"
											>
												<v-icon
													v-bind="attrs"
													size="20"
													v-on="on"
													@click="editarResposta(resposta)"
												>
													mdi-pencil
												</v-icon>
											</template>
											<span>Editar Resposta</span>
										</v-tooltip>
									</v-col>
									<v-col cols="12">
										<v-textarea
											readonly
											v-model="resposta.descricao"
											disabled
											outlined
											rows="4"
											counter="4000"
											class="ma-0 py-0"
										></v-textarea>
									</v-col>
								</v-row>
							</v-list-item-group>
						</v-list>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import { opcaoSimNao } from '@/core/constants'

export default {
	name: 'modal-visualizar-ocorrencia',
	components: {
		Modal,
		LabelPersonalizado,
	},
	props: {
		exibir: {
			type: Boolean,
			default: false,
		},
		titulo: {
			type: String,
			required: true,
		},
		ocorrencia: {
			type: Object,
			required: true,
		},
		hasAuthority: {
			type: Boolean,
		},
	},
	emits: ['fechar-modal', 'editar-resposta'],
	data() {
		return {
			isFormValid: true,
			modalOptions: {
				largura: '1076',
				altura: '1600',
			},
		}
	},
	async created() {},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		habilitaEdicao(resposta) {
			return resposta.habilitaEdicao === opcaoSimNao.SIM.value && this.hasAuthority
		},
		editarResposta(resposta) {
			const payload = {
				ocorrencia: this.ocorrencia,
				resposta,
			}
			this.$emit('editar-resposta', payload)
		},
		isConfirmarVisivel() {
			return false
		},
	},
}
</script>
<style lang="stylus" scoped></style>
